import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { makeTrackingCall } from '../scripts/tracking';
var handleClick = function handleClick(navSubCat, navSubParent, navPosition) {
  var navPos = navPosition === 'side' ? 'Sidebar: ' : 'Topbar: ';
  var prop14 = "Navigation Module: ".concat(navPos).concat(navSubParent, ": ").concat(navSubCat);
  makeTrackingCall(prop14);
};
var Team = function Team(_ref) {
  var _classnames;
  var team = _ref.team,
    navPosition = _ref.navPosition;
  var name = team.name,
    shortName = team.shortName,
    logo = team.logo,
    url = team.url,
    isHomeLink = team.isHomeLink;
  return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: url,
    className: classnames((_classnames = {}, _defineProperty(_classnames, "header__subnav__item", true), _defineProperty(_classnames, "header__subnav--teams__team", true), _defineProperty(_classnames, "header__subnav__item--home-link", isHomeLink), _classnames)),
    "data-sub-nav-name": name,
    "data-parent": "Teams",
    "data-nav-position": navPosition || 'top',
    onClick: function onClick() {
      return handleClick(name, 'Teams', navPosition);
    }
  }, logo && /*#__PURE__*/React.createElement("img", {
    alt: "".concat(name, " Team Logo"),
    src: logo,
    className: "header__subnav--teams__team--logo",
    role: "presentation",
    loading: "lazy"
  }), /*#__PURE__*/React.createElement("span", {
    className: "header__subnav--teams__team--name"
  }, name), /*#__PURE__*/React.createElement("span", {
    className: "header__subnav--teams__team--shortname"
  }, shortName)));
};
export default Team;
Team.propTypes = {
  team: PropTypes.shape({
    name: PropTypes.string,
    shortName: PropTypes.string,
    logo: PropTypes.string,
    url: PropTypes.string,
    isHomeLink: PropTypes.bool
  }).isRequired,
  navPosition: PropTypes.string
};